module.exports = __webpack_public_path__ + "static/img/BW.6c70b6db.png";